import React from "react";
import "./Testimonials.css";
import SectionHeading3 from "../SectionHeadings/Heading3/SectionHeading3";
import {bgShape1, bgShape2, bgShape3} from "../../assets/images";
import MagneticCircleButton from "../Buttons/MagneticCircleButton/MagneticCircleButton";

const Testimonials = ({testimonialsList, isHeadingHide, isButtonHide}) => {
  return (
    <section className="section testimonials-section">
      <div className="testimonials-container container">
        {isHeadingHide && (
          <SectionHeading3
            title={`what My clients\nsay About Me`}
            description="My clients consistently share positive feedback about their experiences working us, highlighting commitment quality, collaboration."
          />
        )}
        <div className="testimonials-wrapper">
          {testimonialsList.map((testimonial, index) => (
            <div className="testimonials-item" key={index}>
              <div className="testimonials-top">
                <div className="testimonials-img">
                  <img src={testimonial.image} alt={`testimonials${index}`} />
                </div>
                <div className="testimonials-review">
                  <div className="star-ratings" style={{width: "160px"}}>
                    <div className="fill-ratings" style={{width: "99%"}}>
                      <span>★★★★★</span>
                    </div>
                    <div className="empty-ratings">
                      <span>★★★★★</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="testimonials-content">
                <p className="testimonials-paragraph">
                  {testimonial.testimonial}
                </p>
                <h5 className="testimonials-name">{testimonial.name}</h5>
                <small>
                  {testimonial.designation} {testimonial.company}
                </small>
              </div>
            </div>
          ))}
        </div>
        {isButtonHide && (
          <div className="explore-more-button">
            <MagneticCircleButton
              text="Let's Read"
              text2="More"
              to="/testimonials"
            />
          </div>
        )}
      </div>
      <div className="wt-testimonial-shape">
        <img className="testimonials-shape-1" src={bgShape1} alt="" />
        <img className="testimonials-shape-2" src={bgShape2} alt="" />
        <img className="testimonials-shape-3" src={bgShape3} alt="" />
      </div>
    </section>
  );
};

export default Testimonials;
